module.exports = __webpack_public_path__ + "img/plattenlegerin_r_d_2891.e5d66a7f.jpg";